export const createTrailerRecordingState = () => ({
  phase: "idle",
  countdownSeconds: 0,
  elapsedSeconds: 0,
  durationSeconds: 0,
  stopRequested: false,
  hasRecording: false,
  recovered: false,
  error: null
})

export const transitionTrailerRecording = (state, event) => {
  switch (event.type) {
    case "record_requested":
      return {
        ...state,
        phase: "countdown",
        countdownSeconds: 3,
        elapsedSeconds: 0,
        stopRequested: false,
        error: null
      }
    case "countdown_tick":
      if (state.phase !== "countdown") return state
      if (state.countdownSeconds > 1) {
        return { ...state, countdownSeconds: state.countdownSeconds - 1 }
      }
      return { ...state, phase: "recording", countdownSeconds: 0 }
    case "elapsed": {
      if (state.phase !== "recording") return state
      const elapsedSeconds = Math.min(Math.max(Number(event.seconds) || 0, 0), 90)
      if (elapsedSeconds < 90) return { ...state, elapsedSeconds }

      return { ...state, phase: "finalizing", elapsedSeconds, stopRequested: true }
    }
    case "stop_requested":
      if (state.phase !== "recording") return state
      return { ...state, phase: "finalizing", stopRequested: true }
    case "capture_started":
      return {
        ...createTrailerRecordingState(),
        phase: "recording"
      }
    case "recording_ready":
      return {
        ...state,
        phase: "ready",
        stopRequested: false,
        hasRecording: true,
        durationSeconds: Math.min(Math.max(Number(event.seconds) || 0, 0), 90),
        recovered: false,
        error: null
      }
    case "recovery_found":
      return {
        ...createTrailerRecordingState(),
        phase: "recoverable",
        hasRecording: true,
        recovered: true,
        durationSeconds: Math.min(Math.max(Number(event.seconds) || 0, 0), 90)
      }
    case "upload_started":
      if (!state.hasRecording) return state
      return { ...state, phase: "uploading", error: null }
    case "upload_failed":
      return {
        ...state,
        phase: "ready",
        hasRecording: true,
        error: event.message || "Upload failed. Try again."
      }
    case "upload_succeeded":
      return { ...createTrailerRecordingState(), phase: "uploaded" }
    case "device_failed":
      if (state.hasRecording) {
        return {
          ...state,
          phase: "ready",
          stopRequested: false,
          error: event.message || "Microphone access failed."
        }
      }
      return {
        ...createTrailerRecordingState(),
        phase: "failed",
        error: event.message || "Microphone access failed."
      }
    case "discarded":
      return createTrailerRecordingState()
    default:
      return state
  }
}
